var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43742 15.5C2.09367 15.5 1.7994 15.3776 1.55461 15.1328C1.30981 14.888 1.18742 14.5938 1.18742 14.25V2.375H0.333252V1.125H4.24992V0.5H9.74992V1.125H13.6666V2.375H12.8124V14.25C12.8124 14.5833 12.6874 14.875 12.4374 15.125C12.1874 15.375 11.8958 15.5 11.5624 15.5H2.43742ZM11.5624 2.375H2.43742V14.25H11.5624V2.375ZM4.64575 12.4583H5.89575V4.14583H4.64575V12.4583ZM8.10408 12.4583H9.35408V4.14583H8.10408V12.4583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin2);
export default __webpack_public_path__ + "static/media/bin-2.659d366ff78ff2f05ef62172fbd02f16.svg";
export { ForwardRef as ReactComponent };